export function pluralize(quantity, singular, plural) {
    return quantity > 1 ? plural || `${singular}s` : singular;
}

export function truncate(value, length) {
    return value.length > length - 3 ? `${value.substr(0, length - 1)}...` : value;
}

export function ordinal(value) {
    let suffixes = ['th', 'st', 'nd', 'rd'];
    let index = value % 100;
    return value + (suffixes[(index - 20) % 10] || suffixes[index] || suffixes[0]);
}

export function toSnakeCase(value) {
    return `${value}`.replace(/[A-Z]/g, (letter) => `-${letter.toLowerCase()}`);
}

export default function numberUtil() {
    return {
        pluralize,
        truncate,
        ordinal,
        toSnakeCase
    };
}



// WEBPACK FOOTER //
// ./src/common/util/string.util.js